import { captureException } from '@sentry/react';
import { toast } from 'sonner';
import { DataContextValue } from '../../../contexts/data-context/data-provider';
import { TransactionView, VendorView } from '../../../types/entity-types';

type ChangeVendorParams = {
  transaction: TransactionView;
  vendorId: string;
  authenticatedFetch: (url: string, options?: RequestInit) => Promise<Response>;
  data: DataContextValue['data'];
  mutations: DataContextValue['mutations'];
};

export const changeVendor = async ({
  transaction,
  vendorId,
  authenticatedFetch,
  data,
  mutations,
}: ChangeVendorParams): Promise<VendorView | null> => {
  try {
    const patchOperation = [
      {
        id: transaction.id,
        patch: [
          {
            op: 'replace',
            path: '/vendorId',
            value: vendorId,
          },
        ],
      },
    ];

    const response = await authenticatedFetch('/api/entities/by-type/transaction', {
      method: 'PATCH',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(patchOperation),
    });

    if (!response.ok) {
      throw new Error('Failed to update vendor category');
    }

    const newVendor = data?.vendors.find((v) => v.id === vendorId) ?? null;
    await mutations.mutateCache?.({
      transactions:
        (data?.transactions ?? []).map((t) =>
          t.id === transaction.id
            ? {
                ...t,
                vendorId,
                vendor: newVendor ?? undefined,
                description: newVendor?.name ?? t.description,
                category: newVendor?.category,
              }
            : t,
        ) ?? [],
      vendors: data?.vendors ?? [],
    });

    return newVendor;
  } catch (error) {
    toast.error('Failed to update transaction vendor');
    captureException(error);
    return null;
  }
};
